import { Center, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { Bluetooth, Check } from 'lucide-react';

type IStep = { step: number; title: string };

interface ISteps {
  data?: IStep[];
  atual?: number;
}

const Steps: React.FC<ISteps> = ({ data, atual }) => {
  const color = useColorModeValue('gray.800', 'white');
  const bg = useColorModeValue('white', 'gray.800');

  return (
    <Flex w="95%" justify="space-between" align="center">
      {data?.map((item, index) => {
        const menorQueAtual = item.step < atual;
        const IgualAtual = item.step === atual;
        const maiorQueAtual = item.step > atual;

        function ajustaStep(menor, igual, maior) {
          if (menorQueAtual) {
            return menor;
          }
          if (maiorQueAtual) {
            return maior;
          }
          return igual;
        }

        return (
          <>
            <Flex align="center" cursor="pointer" py="8">
              <Center
                w="50px"
                h="50px"
                bg={ajustaStep(
                  'rgba(49, 130, 206, 0.8)',
                  'blue.400',
                  'gray.500',
                )}
                color={ajustaStep(bg, bg, bg)}
                rounded="full"
                fontSize={20}
              >
                {menorQueAtual ? <Check /> : item?.step}
              </Center>
              <Text
                ml="3"
                color={item.step === atual ? color : 'gray.500'}
                whiteSpace="nowrap"
                fontWeight="medium"
              >
                {item?.title}
              </Text>
            </Flex>
            {index + 1 !== data.length && (
              <Flex
                h="2px"
                bg={menorQueAtual ? 'blue.500' : 'gray.500'}
                w="100%"
                mx="4"
              />
            )}
          </>
        );
      })}
    </Flex>
  );
};

export default Steps;
